import { render } from "./proofPaid.vue?vue&type=template&id=7ea456bc&scoped=true"
import script from "./proofPaid.vue?vue&type=script&lang=js"
export * from "./proofPaid.vue?vue&type=script&lang=js"

import "./proofPaid.vue?vue&type=style&index=0&id=7ea456bc&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea456bc"]])

export default __exports__